<template>
  <div v-loading="isLoading">
    <div class="flex-row align-center mb-16">
      <label class="label" style="margin-right: 8px;">選擇儀器組</label>
      <el-select
        v-model="selectedGroupId"
        filterable
        placeholder="選擇儀器組"
        style="min-width:260px"
        @change="onGroupChange"
      >
        <el-option
          v-for="group in groupList"
          :key="group._id"
          :label="group.name"
          :value="group._id"
        />
      </el-select>
    </div>

    <template v-if="selectedGroup">
      <el-table :data="groupInstrumentRows" border style="width: 100%;" empty-text="此儀器組沒有儀器">
        <el-table-column type="index" width="50" label="#" />
        <el-table-column prop="name" label="儀器名稱" min-width="200" />
        <el-table-column prop="depth" label="深度" width="100" />
      </el-table>

      <div class="flex-row align-center mt-16">
        <label class="label" style="margin-right: 8px;">遷移到</label>
        <el-select
          v-model="targetProjectId"
          filterable
          placeholder="選擇目標專案"
          style="min-width:260px; margin-right: 16px;"
        >
          <el-option
            v-for="proj in targetProjectOptions"
            :key="proj._id"
            :label="proj.project_id"
            :value="proj._id"
          >
            <span style="margin-right:10px;">{{ proj.project_id }}</span>
            <span style="color:#8492a6; font-size:13px;">{{ proj.name }}</span>
          </el-option>
        </el-select>
        <el-button
          type="primary"
          :disabled="!targetProjectId || groupInstrumentRows.length === 0"
          @click="confirmMigrate"
        >
          遷移整個儀器組
        </el-button>
      </div>
    </template>
    <el-empty v-else description="請先選擇儀器組" />
  </div>
</template>

<script>
export default {
  props: {
    project: {
      type: String,
      required: true,
    },
    instrumentList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      groupList: [],
      selectedGroupId: '',
      targetProjectId: '',
    };
  },
  computed: {
    projectList() {
      return this.$store.getters['project/projectList'];
    },
    targetProjectOptions() {
      return this.projectList.filter(proj => proj._id !== this.project);
    },
    selectedGroup() {
      return this.groupList.find(group => group._id === this.selectedGroupId) || null;
    },
    instrumentNameMap() {
      const map = {};
      this.instrumentList.forEach(ins => {
        map[ins._id] = ins.latestVersion?.name;
      });
      return map;
    },
    groupInstrumentRows() {
      if (!this.selectedGroup) return [];
      return (this.selectedGroup.instrumentList || []).map(item => {
        const name = this.instrumentNameMap[item.instrument];
        return {
          name: name || `${item.instrument}（不在本專案，可能已刪除）`,
          depth: item.depth,
          missing: !name,
        };
      });
    },
  },
  watch: {
    project() {
      this.loadGroupList();
    },
  },
  mounted() {
    this.loadGroupList();
  },
  methods: {
    loadGroupList() {
      this.selectedGroupId = '';
      this.targetProjectId = '';
      if (!this.project) return;
      this.isLoading = true;
      return this.$store
        .dispatch('data/getProjectInstrumentGroupList', { projectId: this.project })
        .then(res => {
          this.groupList = res;
        })
        .catch(this.$notifyError)
        .finally(() => {
          this.isLoading = false;
        });
    },
    onGroupChange() {
      this.targetProjectId = '';
    },
    async confirmMigrate() {
      const count = new Set(
        (this.selectedGroup.instrumentList || []).filter(i => i?.instrument).map(i => String(i.instrument)),
      ).size;
      const targetProject = this.targetProjectOptions.find(proj => proj._id === this.targetProjectId);
      const response = await this.$confirmEdit(
        `確認要將儀器組「${this.selectedGroup.name}」連同底下共 ${count} 個儀器一併遷移到「${targetProject?.project_id || ''}」？`
        + '遷移後此儀器組將不再出現在目前專案的儀器組列表；'
        + '儀器在測站、區域的歸屬不會改變，需要時請另行調整。',
      );
      if (response !== 'confirm') return;
      this.isLoading = true;
      return this.$axios({
        category: 'admin',
        method: 'put',
        apiName: `instrument-group/${this.selectedGroupId}/migrateProject`,
        data: { targetProjectId: this.targetProjectId },
      })
        .then(async () => {
          this.$notifySuccess('儀器組已遷移');
          await Promise.all([
            this.$store.dispatch('data/getProjectInstrumentListWithLatestVersion', {
              projectId: this.project,
              isUpdate: true,
            }),
            this.$store.dispatch('data/getProjectInstrumentListWithLatestVersion', {
              projectId: this.targetProjectId,
              isUpdate: true,
            }),
          ]);
          this.$emit('migrated');
          this.loadGroupList();
        })
        .catch(this.$notifyError)
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
